var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelDeliveryTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(2 2)",
    fill: "#ff5764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.06,12l2.47-2.47a.75.75,0,0,0-1.06-1.06L12,10.94,9.53,8.47A.75.75,0,0,0,8.47,9.53L10.94,12,8.47,14.47a.75.75,0,0,0,1.06,1.06L12,13.06l2.47,2.47a.75.75,0,1,0,1.06-1.06Z",
    fill: "#edebea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelDeliveryTask);
export default __webpack_public_path__ + "static/media/cancelDeliveryTask.842ab522cac022fbad21f4c9178076c0.svg";
export { ForwardRef as ReactComponent };